let _ = require('../_.js');
let $ = jQuery;

_._login_modal_callback_on_success = null;

_.AuctionUI_Login = class AuctionUI_Login {

    static async init() {
        // Hook sign in button
        _.on_ui_update_once(".ac-btn-action-sign-in", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                await _.Modal.hide();
                _.AuctionUI_Login.login_modal();
            });
        });


        // Hook signout button
        _.on_ui_update_once(".ac-btn-action-sign-out", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                await _.Modal.hide();
                _.AuctionUI_Login.signout_clicked();
            });
        });
    }

    // Gets called from elsewhere when the session has been updated.  The session will be accessible
    // through variables _.ac_state.registrant and _.ac_state.registration.
    static session_updated_handler() {
        // Show 'user not registered' area if the user is not registered. A staff user without a registrant
        // is not signed in as a bidder, and can sign in with a bidder account.
        $(".ac-component-bid-not-logged-in").set_conditional_visibility(!_.ac_state.registrant);
        $(".ac-btn-action-sign-in").set_conditional_visibility(!_.ac_state.registrant);
        $(".ac-btn-action-sign-out").set_conditional_visibility(_.ac_state.registrant);
        $(".ac-btn-action-user-settings").set_conditional_visibility(_.ac_state.registrant);

        // $(".ac-component-bid-data").set_conditional_visibility(_.ac_state.registrant);

        let $signed_in_status_widget = $(".ac-component-bid-logged-in-as");

        // In one test this showed up twice.  Lets fix this.
        // Remove all visible elements except the first
        $signed_in_status_widget.filter(":visible").slice(1).remove();

        // Update user's signed in status
        if (_.ac_state.registrant && _.ac_state.registrant.id) {
            $signed_in_status_widget
                .empty()
                .append($("<span>Logged In As:&nbsp;</span>"))
                .append($("<span style='font-weight: bold;'></span>").text(_.full_name(_.ac_state.registrant)))
                .append($("<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>"));

            // console.warn(_.ac_state.registration);

            if (!_.ac_state.registration) {
                $signed_in_status_widget
                    .append($("<span>Not Registered for Bidding</span>"));
            } else if (_.ac_state.registration && !_.ac_state.registration.approved) {
                $signed_in_status_widget
                    .append($("<strong>Registration Pending</strong>"));
            } else if (_.ac_state.registration && _.ac_state.registration.paddle_number) {
                $signed_in_status_widget
                    .append($("<span>Your Paddle Number:&nbsp;</span>"))
                    .append($("<strong>[" + _.ac_state.registration.paddle_number + "]</strong>"));
            }
        } else {
            $signed_in_status_widget.text("Not Logged In");
        }

        // Update main ui.  Spaghetti code...
        _.AuctionUI_Auction_General_UI.update_ui();
    }

    // Displays the login modal.
    static async login_modal(callback_on_success) {

        $("#chatbox").hide();

        _._login_modal_callback_on_success = callback_on_success;

        let form_selector = "#auctioncast-login-form";
        let $form = $(form_selector);

        $("#ac-modal-sign-in").modal_show();

        _.reset_form_errors($form);
        _.reset_form_values($form);

        // Submit button
        _.on_ui_update_once(form_selector, function () {
            $(this).submit_pleasewait(async function (e) {
                e.preventDefault();

                let formValues = _.serialize_form($form);

                formValues.web_session_activity_token = _.Web_Session.get_session_cookie();

                _.reset_form_errors($form);

                try {
                    let response = await _.backend_ajax('session', 'authenticate', formValues, $form);

                    // Handle unified session response
                    if (response) {
                        // Store backend user info if present
                        if (response.backend_user) {
                            localStorage.setItem('landproz_backend_user', JSON.stringify(response.backend_user));
                        } else {
                            localStorage.removeItem('landproz_backend_user');
                        }

                        // Set the unified session token
                        if (response.token) {
                            _.AuctionUI_Session.set_token_cookie(response.token);
                        }

                        // If backend user with auto_auth_key but no registrant, redirect to ACE
                        if (response.backend_user && response.auto_auth_key && !response.registrant) {
                            _.Modal.unclosable("Backend User Authentication", $("<span style='font-weight: bold; font-size: 18px' />").html("Establishing session, redirecting back..."));
                            await _.sleep(500);
                            
                            // Include current page URL as return_to parameter
                            const currentUrl = encodeURIComponent(window.location.href);
                            const aceUrl = _.get_ace_backend_url() + "?auto_auth_key=" + response.auto_auth_key + "&return_to=" + currentUrl;
                            window.location.href = aceUrl;
                        }
                    }

                    // Handle token for both unified and legacy responses
                    let token = response.token;

                    if (token) {
                        _.AuctionUI_Session.set_token_cookie(token);

                        _.Modal.unclosable("Successful Sign In", $("<span style='font-weight: bold; font-size: 18px' />").html("You are now signed in.<br /><br />Please wait..."));

                        // This didn't close on its own once.
                        // This is a failsafe:
                        let did_finish_login = false;
                        setTimeout(function () {
                            if (!did_finish_login) {
                                location.reload();
                            }
                        }, 6000);

                        // Reload all data.
                        await _.data_sync();

                        _.AuctionUI_Session.refresh();

                        await _.sleep(2000);

                        _.Modal.hide();

                        did_finish_login = true;

                        // Refresh chat messages now that there might be private messages.
                        // Maybe move to a on_login event dispatch sort of pattern later.
                        _.AuctionUI_Chat.refresh_chat();

                        await _.sleep(500);

                        // Execute success callback if it was set earlier
                        if (_._login_modal_callback_on_success) {
                            _._login_modal_callback_on_success();
                            _._login_modal_callback_on_success = null;
                        }

                        // On non-auction pages, reload the page to update the header/UI with logged-in state
                        if (!_.ac_state.auction || !_.ac_state.auction.id) {
                            console.log("Reloading page after login (non-auction page)");
                            location.reload();
                        }
                    }

                } catch (error) {
                    if (typeof (error) == "string" && error.indexOf("Invalid") != -1) {
                        _.apply_form_errors($form, { 'password': 'Invalid Email Address Or Password.  <a href="#" class="login-recovery">Trouble Signing In?</a>' });
                        _.ui_update();
                    } else {
                        _.apply_form_errors($form, error);
                    }
                }
            });
        });

        _.on_ui_update_once('.btn-signin-sms', function () {
            $(this).click(async function () {
                await _.Modal.hide();
                _.AuctionUI_Login.login_sms_modal();
            });
        })

        _.on_ui_update_once('.login-recovery', function () {
            $(this).click(async function () {
                await _.Modal.hide();
                _.AuctionUI_Login.login_sms_modal();
            });
        });
    }

    // Displays the login via SMS modal.
    static login_sms_modal() {

        let form_selector = "#auctioncast-login-form-sms";
        let $form = $(form_selector);

        $("#ac-modal-sign-in-sms").modal_show();

        _.reset_form_errors($form);
        _.reset_form_values($form);

        // Submit button
        _.on_ui_update_once(form_selector, function () {
            $(this).submit_pleasewait(async function (e) {
                e.preventDefault();

                let formValues = _.serialize_form($form);

                formValues.web_session_activity_token = _.Web_Session.get_session_cookie();

                _.reset_form_errors($form);

                try {
                    let response = await _.backend_ajax('session', 'authenticate_sms', formValues, $form);

                    _.AuctionUI_Login.login_sms_verify_modal(response);

                } catch (error) {

                    _.apply_form_errors($form, error);

                }
            });
        });

        (async function () {
            await _.sleep(200);
            $("#login-form-sms-phone").focus();
        }())
    }

    // Displays the login sms verification modal, used after the login via SMS modal.
    static login_sms_verify_modal(step1_response) {

        let form_selector = "#ac-modal-sign-in-sms-verify-form";
        let $form = $(form_selector);

        $("#ac-modal-sign-in-sms-verify").modal_show();

        $("#ac-modal-sign-in-sms-first-digit").focus();

        _.reset_form_errors($form);
        _.reset_form_values($form);

        $("#ac-modal-sign-in-sms-verify-thephone").text(_.formatPhoneNumber(step1_response.phone_number));

        // Submit button
        $form.off('submit').on('submit', function (e) {
            e.preventDefault();

            (async function () {
                let data = {
                    signin_verification_challenge: step1_response.signin_verification_challenge,
                    signin_verification_code: $form.find('.thedigits').val(),
                    phone_number: step1_response.phone_number,
                    web_session_activity_token: _.Web_Session.get_session_cookie()
                }

                _.reset_form_errors($form);

                try {
                    let response = await _.backend_ajax('session', 'authenticate_sms_verify', data, $form);
                    await _.AuctionUI_Session.set_token_cookie(response.token);
                    await _.Modal.unclosable("Successful", $("<span style='font-weight: bold; font-size: 18px' />").html("Authentication successful, you are signed in.<br /><br />Please wait..."));
                    await _.AuctionUI_Session.refresh();
                    await _.sleep(2000);
                    await _.Modal.hide();

                    if (_._login_modal_callback_on_success) {
                        _._login_modal_callback_on_success();
                        _._login_modal_callback_on_success = null;
                    }

                } catch (error) {
                    _.apply_form_errors($form, error);
                    _.reset_form_values($form);
                    $("#ac-modal-sign-in-sms-first-digit").focus();
                }
            }());
        });
    }

    // Handler for the signout button being clicked.
    static async signout_clicked(confirm = true) {
        if (!confirm || await _.Modal.confirm("Are you sure you would like to sign out?")) {
            await _.AuctionUI_Session.logout();
            await _.Modal.unclosable("Signing Out", $("<span style='font-weight: bold; font-size: 18px' />").html("You are now signed out.<br /><br />Please wait..."));

            // Refresh session in the background (don't await to avoid delay)
            _.AuctionUI_Session.refresh();

            // Wait exactly 2 seconds before reload
            await _.sleep(2000);
            location.reload();
            // await _.Modal.hide();
        }
    }

}